const PbxxRecord = require('../../pbxx_record')

module.exports = class PulseSocialStatistics extends PbxxRecord {
  static get class_name() {
    return 'PulseSocialStatistics'
  }
}
